import type { SchemaOf, DeepPartial } from '../helpers';
import { objectSchemaOf, makeAllOptional } from '../helpers';
import type { IEnvConfig, IEnvConfigMap } from '../apps/envConfigs';
import { envConfigSchemaMap } from '../apps/envConfigs';

/* eslint-disable-next-line @typescript-eslint/no-empty-interface*/
export interface IMobileEnvConfig extends IEnvConfig {}

const mobileEnvConfigSchemaMap: SchemaOf<IMobileEnvConfig> = {
  ...envConfigSchemaMap,
};

export const mobileEnvConfigSchema = objectSchemaOf<IEnvConfig>(
  mobileEnvConfigSchemaMap
);

export const mobileEnvConfigPartialSchemaMap = makeAllOptional(
  mobileEnvConfigSchemaMap
);

export const mobileEnvConfigPartialSchema = objectSchemaOf<
  DeepPartial<IEnvConfig>
>(mobileEnvConfigSchemaMap);

export type IMobileEnvConfigMap = IEnvConfigMap<IMobileEnvConfig>;
